export default "__VITE_ASSET__s6J$AlGO__"